import '../styles/index.scss';

import initBackgroundColor from './background-color.mjs';
import initExtraSideScroller from './extra-side-scroller.mjs';
import initHighlightColumn from './highlight-column.mjs';
import initCategoryPaginationFilter from './category-pagination-filter.mjs';
import initMenuToggle from './menu-toggle.mjs';
import initTableWrapper from './table-wrapper.mjs';
import initImageGalleryModal from './image-gallery-modal.mjs';
import initSiteSearch from './site-search.mjs';
import initScrollAnimations from './scroll-animations.mjs';

initBackgroundColor();
initExtraSideScroller();
initHighlightColumn();
initCategoryPaginationFilter();
initMenuToggle();
initTableWrapper();
initImageGalleryModal();
initSiteSearch();
initScrollAnimations();
